module.exports = __webpack_public_path__ + "media/images/og-69b8ee34cc52a8d86e4bd42da58b5463.png";